import React, { useRef, useState, useEffect } from 'react'
import { Paper, Stack, Typography, Box, Button, OutlinedInput, Grid, IconButton, TextField } from '@mui/material';
import { secondaryTypography, ErrorTypography } from '../../Theme/theme';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ClearIcon from '@mui/icons-material/Clear';
import { fontSize } from '@mui/system';
import axiosInstance from '../../Service/apiservice';
import { useParams } from 'react-router-dom';

export default function EditCompany() {

    const { id } = useParams()

    const [companyData, setCompanyData] = useState({
        company_name: '',
        slug: '',
        domain_name: '',
        official_email: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        zipcode: '',
        description: '',
        first_name: "",
        last_name: "",
        email: ''
    })
    const [errText, setErrText] = useState({})

    const [coverImg, setCoverImg] = useState(null)
    const coverimageRef = useRef()
    const [logoImg, setlogoImg] = useState(null)
    const logoimageRef = useRef()

    console.log(companyData);

    const handleChange = (e) => {
        const { name, value } = e.target
        setCompanyData((prev) => ({ ...prev, [name]: value }))

        setErrText((prev) => ({ ...prev, [name]: '' }))
    }

    const handlecoverImage = (e) => {
        const file = e.target.files[0]
        if (file) {
            setCoverImg({ file: file, url: URL.createObjectURL(file) })
            setErrText((prev) => ({ ...prev, coverImg: '' }))
        }
    }
    const handlelogoImage = (e) => {
        const file = e.target.files[0]
        if (file) {
            setlogoImg({ file: file, url: URL.createObjectURL(file) })
            setErrText((prev) => ({ ...prev, logoImg: '' }))
        }
    }

    const valid = () => {
        let isValid = true
        for (const key in companyData) {
            if ((companyData[key] == '') || (companyData[key] == null)) {
                setErrText((prev) => ({ ...prev, [key]: 'Required field !' }))
                isValid = false
            }
        }
        if (coverImg == null) {
            setErrText((prev) => ({ ...prev, coverImg: 'please upload Image' }))
        }
        if (logoImg == null) {
            setErrText((prev) => ({ ...prev, logoImg: 'please upload Image' }))
        }
        return isValid
    }
    const submit = () => {
        if (valid()) {
            postData()
        }
    }

    useEffect(() => {

        getCompany()

    }, [])


    const getCompany = async () => {
        try {
            const response = await axiosInstance.get(`https://bsmartsg.com/backend/api/company/${id}`)
            console.log(response?.data?.data?.company);
            const data = response?.data?.data?.company
            setCompanyData({
                company_name: data?.company_name,
                slug: data?.slug,
                domain_name: data?.domain,
                official_email: data?.official_email,
                phone: data?.phone,
                address: data?.address,
                city: data?.city,
                country: data?.country,
                zipcode: data?.zipcode,
                description: data?.description,
                first_name: data?.first_name,
                last_name: data?.last_name,
                email: data?.email
            })
            setlogoImg({ url: data?.logo })
            setCoverImg({ url: data?.cover_image })

        }
        catch (err) {
            console.log(err);
        }
    }

    const postData = async () => {
        const data = new FormData()

        data.append('slug', companyData?.slug)
        data.append('company_name', companyData?.company_name)
        data.append('official_email', companyData?.official_email)
        data.append('domain', companyData?.domain_name)
        data.append('description', companyData?.description)
        data.append('logo', logoImg?.file)
        data.append('cover_image', coverImg?.file)
        data.append('first_name', companyData?.first_name)
        data.append('last_name', companyData?.last_name)
        data.append('email', companyData?.email)
        data.append('phone', companyData?.phone)
        data.append('country_code', '')
        data.append('address', companyData?.address)
        data.append('country', companyData?.country)
        data.append('city', companyData?.city)
        data.append('zipcode', companyData?.zipcode)

        try {
            const response = await axiosInstance.post("https://bsmartsg.com/backend/api/company", data)
            console.log(response);
        } catch (error) {
            console.log(error);
        }

    }


    // console.log(process.env.REACT_APP_WMS_IMG_BASE_URL  logoImg?.url);

    return (<>
        <h2 style={{ color: "rgb(33 91 85 / 87%)" }}>Company Details</h2>
        <Box mb={7} backgroundColor='#FFFFFF' p={2} sx={{ borderRadius: "8px", boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)" }}>
            <Grid container >
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Company Name</secondaryTypography>
                    <TextField name='company_name' onChange={(e) => handleChange(e)} value={companyData?.company_name} placeholder="Please enter company name" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.company_name}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Slug</secondaryTypography>
                    <TextField name='slug' onChange={(e) => handleChange(e)} value={companyData?.slug} placeholder="Please enter slug" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.slug}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Domain Name</secondaryTypography>
                    <TextField name='domain_name' onChange={(e) => handleChange(e)} value={companyData?.domain_name} placeholder="Please enter domain name" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.domain_name}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Official Email</secondaryTypography>
                    <TextField name='official_email' onChange={(e) => handleChange(e)} value={companyData?.official_email} placeholder="Please enter email" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.official_email}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Phone</secondaryTypography>
                    <TextField type='number' name='phone' onChange={(e) => handleChange(e)} value={companyData?.phone} placeholder="Please enter phone number" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.phone}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Address</secondaryTypography>
                    <TextField name='address' onChange={(e) => handleChange(e)} value={companyData?.address} placeholder="Please enter address" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.address}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>City</secondaryTypography>
                    <TextField name='city' onChange={(e) => handleChange(e)} value={companyData?.city} placeholder="Please enter city" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.city}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Country</secondaryTypography>
                    <TextField name='country' onChange={(e) => handleChange(e)} value={companyData?.country} placeholder="Please enter country" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.country}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>ZipCode</secondaryTypography>
                    <TextField name='zipcode' onChange={(e) => handleChange(e)} value={companyData?.zipcode} placeholder="Please enter zipcode" InputProps={{ disableUnderline: true }} inputProps={{ maxLength: 6 }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.zipcode}</ErrorTypography>
                </Grid>
                <Grid sm={12} p={2}>
                    <secondaryTypography mb={1.2}>Description</secondaryTypography>
                    <TextField name='description' onChange={(e) => handleChange(e)} value={companyData?.description} sx={{ minHeight: '100px' }} placeholder="Please enter description" InputProps={{ disableUnderline: true }} multiline />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.description}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <secondaryTypography mb={1.2}>Logo Image</secondaryTypography>
                    {coverImg == null ?
                        <>
                            <Box mt={1} onClick={() => coverimageRef.current.click()} sx={{ borderStyle: "dashed", borderColor: " #56b9dc", width: 'fit-content', borderRadius: "8px", borderWidth: "2px", padding: "5px 10px 0px 10px" }}>
                                <CloudUploadIcon sx={{ fontSize: '2.5rem !important', color: "#56b9dc" }} />
                            </Box>
                        </>
                        :
                        <Box mt={1} sx={{ position: 'relative', borderStyle: "dashed", borderColor: " #56b9dc", width: 'fit-content', borderRadius: "8px", borderWidth: "2px", padding: "5px 10px 0px 10px" }}>
                            <img src={process.env.REACT_APP_WMS_IMG_BASE_URL + coverImg?.url} width='150px' height='150px' style={{ objectFit: 'cover' }} />
                            <IconButton onClick={() => setCoverImg(null)} sx={{ position: 'absolute', top: '-20px' }}>
                                <ClearIcon sx={{ fontSize: '2rem !important', }} />
                            </IconButton>
                        </Box>
                    }
                    <input type='file' ref={coverimageRef} onChange={(e) => handlecoverImage(e)} hidden />

                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.coverImg}</ErrorTypography>

                </Grid>
                <Grid sm={4} p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <secondaryTypography mb={1.2}>Logo Image</secondaryTypography>
                    {logoImg == null ?
                        <>
                            <Box mt={1} onClick={() => logoimageRef.current.click()} sx={{ borderStyle: "dashed", borderColor: " #56b9dc", width: 'fit-content', borderRadius: "8px", borderWidth: "2px", padding: "5px 10px 0px 10px" }}>
                                <CloudUploadIcon sx={{ fontSize: '2.5rem !important', color: "#56b9dc" }} />
                            </Box>
                        </>
                        :
                        <Box mt={1} sx={{ position: 'relative', borderStyle: "dashed", borderColor: " #56b9dc", width: 'fit-content', borderRadius: "8px", borderWidth: "2px", padding: "5px 10px 0px 10px" }}>
                            <img src={process.env.REACT_APP_WMS_IMG_BASE_URL + logoImg?.url} width='150px' height='150px' style={{ objectFit: 'cover' }} />
                            <IconButton onClick={() => setlogoImg(null)} sx={{ position: 'absolute', top: '-20px' }}>
                                <ClearIcon sx={{ fontSize: '2rem !important', }} />
                            </IconButton>
                        </Box>
                    }
                    <input type='file' ref={logoimageRef} onChange={(e) => handlelogoImage(e)} hidden />

                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.logoImg}</ErrorTypography>

                </Grid>
            </Grid>
        </Box>
        <h2 style={{ color: "rgb(33 91 85 / 87%)" }}>Incharge Details</h2>
        <Box mb={5} backgroundColor='#FFFFFF' p={2} sx={{ borderRadius: "8px", boxShadow: "0 0 10px 0 rgba(0,0,0,0.2)" }}>
            <Grid container >
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>First Name</secondaryTypography>
                    <TextField name='first_name' onChange={(e) => handleChange(e)} value={companyData?.first_name} placeholder="Please enter first name" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.first_name}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Last Name</secondaryTypography>
                    <TextField name='last_name' onChange={(e) => handleChange(e)} value={companyData?.last_name} placeholder="Please enter last name" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.last_name}</ErrorTypography>
                </Grid>
                <Grid sm={4} p={2}>
                    <secondaryTypography mb={1.2}>Email</secondaryTypography>
                    <TextField name='email' onChange={(e) => handleChange(e)} value={companyData?.email} placeholder="Please enter email" InputProps={{ disableUnderline: true }} />
                    <ErrorTypography mt={1} fontSize='.9rem' color='error'>{errText?.email}</ErrorTypography>
                </Grid>
            </Grid>
        </Box>
        <Stack mb={5} alignItems='end'>
            <Button variant='contained' onClick={submit}>Submit</Button>
        </Stack>
    </>
    )
}
